import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { fetchCustomer, createCustomer } from '../services/customerApi.js'

const useCustomer = customerId => {
  const dispatch = useDispatch()
  const { singleCustomer, loading, error } = useSelector(state => state.customer)

  useEffect(() => {
    if (customerId) {
      dispatch(fetchCustomer(customerId))
    }
  }, [dispatch, customerId])

  return {
    customer: singleCustomer,
    loading,
    error,
    fetchCustomer: customerId => dispatch(fetchCustomer(customerId)),
    createCustomer: data => dispatch(createCustomer(data)),
  }
}

export default useCustomer
